/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertySharingDestination } from './PropertySharingDestination';
/**
 * Successfully selected customer-facing URL.
 */
export type ResolvedPropertySharingLink = {
    /**
     * A complete selected URL is available.
     */
    status: ResolvedPropertySharingLink.status;
    /**
     * The exact URL to use when sharing; sourceUrl is provenance only.
     */
    url: string;
    /**
     * Destination selected by the backend priority chain.
     */
    destination: PropertySharingDestination;
    /**
     * Time at which the selection was evaluated.
     */
    resolvedAt: string;
};
export namespace ResolvedPropertySharingLink {
    /**
     * A complete selected URL is available.
     */
    export enum status {
        RESOLVED = 'resolved',
    }
}

